module.exports = __webpack_public_path__ + "static/media/16.9d2fe9fb.png";